import "./ErrorSummary.scss";

const fieldLabels: Record<string, string> = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  mobile_number: "Mobile",
  reporting_manager_id: "Reporting manager",
  profileImageLive: "Profile photo",
};

const ErrorSummary = ({ errors }: { errors: Record<string, string> }) => {
  const errorEntries = Object.entries(errors).filter(([field]) => {
    if (field === "mobile_country_code") return false;
    return true;
  });

  if (!errorEntries.length) return null;

  return (
    <>
      <div className="error-summary">
        <div className="error-header">
          <span className="error-icon">!</span>
          <span>Errors in form!</span>
        </div>
        <div className="error-message">
          Please fix the following errors to submit the request
        </div>
      </div>

      <div>
        <ul className="error-list">
          {errorEntries.map(([field, message]) => (
            <li key={field}>
              {(fieldLabels[field] || field)} {message}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ErrorSummary;